import React, { useCallback } from 'react';
import { Column, LoadingDots, LoadingSpinner, Row } from '@mattilsynet/mt-ui';
import { useMattilsynetDeltakere } from '../index';
import { useTypedSelector } from '../../../common/custom-hooks';
import { useDeltakereFns, useRemoveEmptyDeltaker } from '../hooks/component-hooks';
import { DeleteModal } from '../../../modals';
import { userSelectors } from '../../../ducks/user/selectors';
import SkjulNavn from './skjul-navn';
import AddDeltaker from './add-deltaker';
import { DeltakerItem } from './deltaker-item';
import { DeltakerTypes } from '../types';
import { useKvitteringId } from '../../../common/kvittering-context';
export const MattilsynetDeltakere = () => {
  const user = useTypedSelector(userSelectors.getAuthUser);
  const kvitteringId = useKvitteringId();
  const deltakere = useMattilsynetDeltakere(kvitteringId);
  const {
    onAdd,
    onUpdate,
    onRemove,
    shouldAutoFocus,
    remove,
    setDeltakerToBeRemoved,
    hasError,
    deltakerToBeRemoved,
    isAddLoading
  } = useDeltakereFns(deltakere, kvitteringId, DeltakerTypes.MATTILSYNET);
  useRemoveEmptyDeltaker(deltakere.data ?? [], onRemove);
  const onCancelRemove = useCallback(() => setDeltakerToBeRemoved(undefined), [setDeltakerToBeRemoved]);
  const filteredDeltakere = deltakere.data?.filter(deltaker => user?.name.trimEnd() !== deltaker.navn.trimEnd()) ?? [];
  return <>
      <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="mattilsynet-deltakere.tsx">
        <Column spacing={2} data-sentry-element="Column" data-sentry-source-file="mattilsynet-deltakere.tsx">
          <Row className="info-header" data-sentry-element="Row" data-sentry-source-file="mattilsynet-deltakere.tsx">Fra Mattilsynet</Row>

          {deltakere.isLoading && <Row center>
              <LoadingSpinner title={'Laster deltakerer...'} small />
            </Row>}

          {!deltakere.isLoading && <>
              <Row>{user?.name}</Row>
              {filteredDeltakere.map(deltaker => <DeltakerItem key={deltaker.id} deltaker={deltaker} onUpdateDeltaker={onUpdate} onRemoveDeltaker={onRemove} autoFocus={shouldAutoFocus(deltaker)} danger={hasError} />)}
            </>}
        </Column>

        {(isAddLoading || deltakere.isFetching && deltakere.data?.length === 0) && <Row justify="center">
            <LoadingDots />
          </Row>}

        {!deltakere.isLoading && <>
            <AddDeltaker onAdd={onAdd} />
            <SkjulNavn />
          </>}
      </Column>

      <DeleteModal isOpen={!!deltakerToBeRemoved} onCancel={onCancelRemove} onDelete={remove} title="Er du sikker på at du vil slette deltaker?" confirmText="Ja, jeg vil slette deltaker" cancelText="Avbryt" data-sentry-element="DeleteModal" data-sentry-source-file="mattilsynet-deltakere.tsx" />
    </>;
};